"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var platform;
        (function (platform) {
            var environments;
            (function (environments) {
                class InitArgs {
                    constructor() {
                        this.columnCount = 0;
                        this.columnWidths = 0;
                        this.platformCreateEnvironment = appn.emptyString;
                        this.platformAddExistingEnvironment = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dataTable = null;
                function init(args) {
                    _initArgs = args;
                    createDataTable();
                }
                environments.init = init;
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        iDisplayLength: 25,
                        bProcessing: true,
                        bServerSide: true,
                        sAjaxSource: 'EnvironmentsDataTable',
                        fnServerData: function (data, callback) {
                            data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked')));
                        },
                        autoWidth: false,
                        aoColumns: getDtColConfiguration(),
                        fnInitComplete: function () {
                            $('#addexisting').click(function (event) {
                                event.preventDefault();
                                appn.location.navTo(_initArgs.platformAddExistingEnvironment);
                            });
                            $('#addnew').click(function (event) {
                                event.preventDefault();
                                appn.location.navTo(_initArgs.platformCreateEnvironment);
                            });
                            $('.dataTables_filter').prepend(appn.elementBuilder.buildCheckbox(appn.strings.showRetired, 'saveMeState', 'sCustom_0')).append($('.dt-action-button'));
                            appn.dataTable.addSearchPlaceholder(T('Filter results where the Environments <b>Name or Status</b> contains a keyword typed in here.'));
                            $('.dataTables_controls_start').append($('.dt-action-title'));
                            appn.saveMeState.init(function () {
                                _dataTable.fnDraw(false);
                            }, function () {
                                _dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                        },
                        fnDrawCallback: function () {
                            $('.rowOptions').hide();
                            $('.dataTable tr').hover(function () {
                                $(this).find('.rowOptions').show();
                            }, function () {
                                $(this).find('.rowOptions').hide();
                            });
                        }
                    });
                }
                function getDtColConfiguration() {
                    const aoColumns = [];
                    aoColumns.push({ bSortable: true, sWidth: '35%' });
                    for (let i = 1; i < _initArgs.columnCount; i++)
                        aoColumns.push({ bSortable: true, sWidth: `${_initArgs.columnWidths}%` });
                    aoColumns.push({ bSortable: true, sWidth: '15%' }, { bSortable: true, sWidth: '15%' });
                    return aoColumns;
                }
            })(environments = platform.environments || (platform.environments = {}));
        })(platform = views.platform || (views.platform = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
